import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen bg-ivory text-ink">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
